import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import CustomSelect from "~components/CustomSelect";
import type { RoleStatuses } from "~enums/roleStatuses";
import type { Roles } from "~enums/roles";
import { getRoleTranslationKey } from "~utilities/getRoleTranslationKey";
import classNames from "~utils/classNames";
import styles from "./SeasonOfficialsFilters.module.css";

type Props = {
  officialRoles: Roles[];
  setFilteredRoles: Dispatch<SetStateAction<Roles[]>>;
  setFilteredStatus: Dispatch<SetStateAction<RoleStatuses | undefined>>;
  roleStatuses: RoleStatuses[];
  disabled?: boolean;
  className?: string;
};

export const SeasonOfficialsFilters = ({
  officialRoles,
  setFilteredRoles,
  setFilteredStatus,
  roleStatuses,
  disabled = false,
  className,
}: Props) => {
  const { sport = "" } = useParams<{ sport: string }>();
  const { formatMessage } = useIntl();

  return (
    <div className={classNames(className, styles.filters)}>
      <CustomSelect
        onChange={(values) => setFilteredStatus(values as RoleStatuses)}
        options={roleStatuses.map((status) => ({
          label: formatMessage({ id: `roleStatus.${status}` }),
          value: status,
        }))}
        allowClear
        placeholder={formatMessage({ id: "status" })}
        className={styles.filter}
        disabled={disabled}
      />
      <CustomSelect
        mode="multiple"
        onChange={(values) => setFilteredRoles(values as Roles[])}
        options={officialRoles.map((role) => ({
          label: formatMessage({
            id: `roles.${getRoleTranslationKey(role, sport)}`,
          }),
          value: role,
        }))}
        allowClear
        placeholder={formatMessage({ id: "role" })}
        className={styles.filterLong}
        disabled={disabled}
        maxTagCount="responsive"
      />
    </div>
  );
};
